module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"de":{"No subject":"Ohne Betreff"}}')
  delete Component.options._Ctor
}
